import { render, staticRenderFns } from "./InvitedUserListModal.vue?vue&type=template&id=5b71c24f&scoped=true&"
import script from "./InvitedUserListModal.vue?vue&type=script&lang=js&"
export * from "./InvitedUserListModal.vue?vue&type=script&lang=js&"
import style0 from "./InvitedUserListModal.vue?vue&type=style&index=0&id=5b71c24f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b71c24f",
  null
  
)

export default component.exports